// ProductNew
(() => {
  if (customElements.get("product-new")) return;

  class ProductNew extends HTMLElement {
    constructor() {
      super();

      this.buyForm = this.querySelector("form[data-product-new-buy-buttons]");
      this.productIdInput = this.buyForm.querySelector("[name='product-id']");
      this.variantInputsWrapper = this.buyForm.querySelector("[data-product-new-buy-buttons-inputs]");
      // Get button regardless of type (submit or button)
      this.buyButton = this.buyForm.querySelector(".product-new-buy-buttons__add-to-cart") || 
                       this.buyForm.querySelector("button[type='submit']") ||
                       this.buyForm.querySelector("button.klaviyo-bis-trigger");
      this.cartDrawer = document.querySelector("cart-drawer");
      this.sectionId = this.dataset.sectionId;
      
      // Store original button HTML structure for restoration
      this.originalButtonHTML = this.buyButton ? this.buyButton.innerHTML : null;
      
      // Quantity component can be anywhere in the DOM now (separate block)
      this.quantityComponent = document.querySelector("product-new-form-quantity");

      this.selectedProducts = Array(3).fill(null);
      this.isPDP = this.hasAttribute("data-is-pdp");

      this.onSubmit = this.onSubmitHandler.bind(this);
      this.setEventListeners();
    }

    setEventListeners() {
      this.buyForm.addEventListener("submit", this.onSubmit);
      this.buyButton.addEventListener("click", this.onSubmit);
    }

    updateProductInfo(selectedProduct, position) {
      this.selectedProducts[position - 1] = selectedProduct || null;

      if (position === 1 && selectedProduct) {
        this.#updateUrl(selectedProduct.url);
        this.#updateMediaLayout(selectedProduct.media_layout);
        this.#updateDescription(selectedProduct.description);
        this.#updateProductId(selectedProduct.product_id);
      }

      this.#updateBuyButtonState();
      this.#buildVariantInputs();

      window.queueMicrotask(() => {
        if(this.quantityComponent){
          this.quantityComponent.updateLayout(this.selectedProducts);
        }
      });
    }

    #updateUrl(url) {
      if (!this.isPDP) return;
    }

    #updateMediaLayout(mediaLayout) {
      const productMedia = this.querySelector("product-new-media");
      if (productMedia) productMedia.outerHTML = mediaLayout;
    }

    #updateDescription(description) {
      const descriptionEl = this.querySelector("[data-product-new-description]");
      if (descriptionEl) descriptionEl.innerHTML = description;
    }

    #updateProductId(productId) {
      this.productIdInput.value = productId;
      this.buyForm.dispatchEvent(new Event("change"));
    }

    #updateBuyButtonState() {
      const available = this.selectedProducts.filter(Boolean).every((product) => product.available);
      const selectedProduct = this.selectedProducts[0];
      
      if (!this.buyButton) return;
      
      if (available && selectedProduct) {
        // Variant is available - show Add to Cart button
        this.buyButton.type = "submit";
        this.buyButton.removeAttribute("disabled");
        this.buyButton.classList.remove("klaviyo-bis-trigger");
        this.buyButton.classList.add("product-new-buy-buttons__add-to-cart", "button", "button--full", "button--primary");
        this.buyButton.removeAttribute("data-product-variant");
        
        // Restore or create button text structure
        let buttonText = this.buyButton.querySelector('.product-new-buy-buttons__add-to-cart-text');
        if (!buttonText) {
          // If no text span exists, create one
          buttonText = document.createElement('span');
          buttonText.className = 'product-new-buy-buttons__add-to-cart-text';
          this.buyButton.innerHTML = '';
          this.buyButton.appendChild(buttonText);
          
          // Get the original text from stored HTML or use default
          let baseText = 'Add to Cart';
          let needsPriceFormat = false;
          
          if (this.originalButtonHTML) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = this.originalButtonHTML;
            const originalText = tempDiv.querySelector('.product-new-buy-buttons__add-to-cart-text');
            if (originalText) {
              const originalContent = originalText.textContent;
              if (originalContent.includes('•')) {
                baseText = originalContent.split('•')[0].trim();
                needsPriceFormat = true;
              } else {
                baseText = originalContent.trim();
              }
            }
          }
          
          // Check if we're in static mode (price should be shown)
          const isStaticMode = this.quantityComponent?.hasAttribute('data-static-mode');
          if (isStaticMode || needsPriceFormat) {
            // Add placeholder that will be updated by #buildVariantInputs()
            buttonText.textContent = `${baseText} • `;
          } else {
            buttonText.textContent = baseText;
          }
        }
      } else if (selectedProduct) {
        // Variant is not available - show Notify Me button

        // this.buyButton.type = "button";
        // this.buyButton.disabled = true;

        // this.buyButton.removeAttribute("disabled");
        // this.buyButton.classList.add("klaviyo-bis-trigger", "product-new-buy-buttons__add-to-cart", "button", "button--full", "button--primary");
        // this.buyButton.setAttribute("data-product-variant", selectedProduct.variant_id);
        // this.buyButton.textContent = "Sold Out";


        this.buyButton.type = "button";
        this.buyButton.removeAttribute("disabled");
        this.buyButton.classList.add("klaviyo-bis-trigger", "product-new-buy-buttons__add-to-cart", "button", "button--full", "button--primary");
        this.buyButton.setAttribute("data-product-variant", selectedProduct.variant_id);
        // this.buyButton.textContent = "Notify Me When Available";
      } else {
        // No product selected
        this.buyButton.disabled = true;
      }
    }

    #buildVariantInputs() {
      const productsCount = this.selectedProducts.filter(Boolean).length;
      const html = this.selectedProducts.reduce((acc, product) => {
        if (!product?.variant_id) return acc;
        const name = productsCount === 1 ? "id" : "id[]";
        return `<input type="hidden" name="${name}" value="${product.variant_id}" />` + acc;
      }, "");

      if (this.selectedProducts && this.selectedProducts[0] && this.selectedProducts[0].price !== undefined) {
        const price = this.selectedProducts[0].price;
        const formattedPrice = Math.round(price / 100); 
        
        // Update price in button text if in static mode
        const buttonText = this.buyButton.querySelector('.product-new-buy-buttons__add-to-cart-text');
        if (buttonText && buttonText.textContent.includes('•')) {
          const text = buttonText.textContent.split('•')[0].trim();
          let html = `${text} • $${formattedPrice}`
          if (this.selectedProducts[0].sale_price) {
            html = `${text} • <span class="discount-price__container"><span class="discount-price">$${formattedPrice}</span>`
            // html = `${text} • <span class="discount-price__container">${this.selectedProducts[0].sale_price}<span class="discount-price">$${formattedPrice}</span>`
          }
          buttonText.innerHTML = html;
        }
        
        const updatedPrice = document.querySelector(
          '.product-new-blocks__block .product-new-buy-buttons__add-to-cart .product-price'
        );
        const mainPrice = document.querySelector('.product-new-blocks .product-new-blocks__block .product_price');
        if (updatedPrice) {
          if (this.selectedProducts[0].sale_price) {
            updatedPrice.innerHTML = `<span class="discount-price__container">${this.selectedProducts[0].sale_price}<span class="discount-price">$${formattedPrice}</span>`
          } else {
            updatedPrice.innerHTML = formattedPrice;
          }
        }
        if (mainPrice) {
          if (this.selectedProducts[0].sale_price) {
            mainPrice.innerHTML = `<span class="discount-price__container">${this.selectedProducts[0].sale_price}<span class="discount-price">$${formattedPrice}</span>`
          } else {
            mainPrice.innerHTML = '$' + formattedPrice;
          }
        }
      }
      
      this.variantInputsWrapper.innerHTML = html;
      
    }

    onSubmitHandler(evt) {
      // Check if this is a notify button (Klaviyo back-in-stock trigger)
      // If so, don't prevent default and let Klaviyo handle it
      if (this.buyButton && this.buyButton.classList.contains("klaviyo-bis-trigger")) {
        return; // Let Klaviyo handle the click
      }

      evt.preventDefault();

      this.cartDrawer = document.querySelector("cart-drawer");
      
      this.buyButton.setAttribute("disabled", true);
      this.buyButton.classList.add("loading");

      const bodyFormData = new FormData(this.buyForm);
      const sections = this.getSectionsToRender();

      bodyFormData.append(
        "sections",
        sections.map((sec) => sec.section)
      );
      bodyFormData.append("sections_url", window.location.pathname);

      fetch(routes.cart_add_url, {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/javascript",
        },
        body: bodyFormData,
      })
        .then((response) => response.json())
        .then((parsedState) => {
          if (!parsedState || !parsedState.sections) {
            console.error("Invalid response from cart add:", parsedState);
            return;
          }
          
          sections.forEach((section) => {
            const container = document.getElementById(section.id);
            if (!container) return;
            
            const sectionHTML = parsedState.sections[section.section];
            if (!sectionHTML) {
              console.warn(`Section ${section.section} not found in response`);
              return;
            }
            
            const elementToReplace = container.querySelector(section.selector) || container;
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              sectionHTML,
              section.selector
            );
          });
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.buyButton.classList.remove("loading");
          this.buyButton.removeAttribute("disabled");
          if (this.cartDrawer) {
            this.cartDrawer.open();
          }
        });
    }

    getSectionsToRender() {
      return [
        {
          id: "cart-drawer__content",
          section: document.getElementById("cart-drawer__content").dataset.id,
          selector: ".cart-drawer__content",
        },
        {
          id: "cart-item-count",
          section: document.getElementById("cart-drawer__content").dataset.id,
          selector: "#cart-item-count",
        },
        {
          id: "cart-icon-bubble",
          section: "cart-icon-bubble",
          selector: ".shopify-section",
        },
        {
          id: "cart-upsell-price",
          section: this.sectionId,
          selector: ".product-upsell__button .price",
        },
      ];
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
    }
  }

  customElements.define("product-new", ProductNew);
})();

// ProductNewMedia
(() => {
  if (customElements.get("product-new-media")) return;

  class ProductNewMedia extends HTMLElement {
    constructor() {
      super();

      this.mainSwiperEl = this.querySelector("[data-main-swiper]");
      this.thumbsSwiperEl = this.querySelector("[data-thumbs-swiper]");

      this.initSwipers();
    }

    disconnectedCallback() {
      this.mainSwiper?.destroy(true, true);
      this.thumbsSwiper?.destroy(true, true);
    }

    initSwipers() {
      this.thumbsSwiper = new Swiper(this.thumbsSwiperEl, {
        slidesPerView: "auto",
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
      });

      this.mainSwiper = new Swiper(this.mainSwiperEl, {
        effect: "fade",
        fadeEffect: { crossFade: true },
        thumbs: { swiper: this.thumbsSwiper },
      });
    }
  }

  customElements.define("product-new-media", ProductNewMedia);
})();

// ProductNewReviews
(() => {
  if (customElements.get("product-new-reviews")) return;

  class ProductNewReviews extends HTMLElement {
    constructor() {
      super();

      this.swiperEl = this.querySelector("[data-swiper]");
      this.prevBtn = this.querySelector("[data-swiper-prev]");
      this.nextBtn = this.querySelector("[data-swiper-next]");

      this.initSwiper();
    }

    initSwiper() {
      this.swiper = new Swiper(this.swiperEl, {
        slidesPerView: "auto",
        spaceBetween: 12,
        navigation: {
          nextEl: this.nextBtn,
          prevEl: this.prevBtn,
        },
        breakpoints: {
          769: {
            loop: true,
            centeredSlides: true,
            spaceBetween: 24,
          },
        },
      });
    }
  }

  customElements.define("product-new-reviews", ProductNewReviews);
})();

// ProductNewForm
(() => {
  if (customElements.get("product-new-form")) return;

  class ProductNewForm extends HTMLElement {
    constructor() {
      super();

      const jsonEl = this.querySelector("[data-product-new-json]");
      this.json = JSON.parse(jsonEl.textContent);
      this.productComponent = this.closest("product-new");
      this.quantity = 1;
      this.isPDP = document.querySelector('.product-new').hasAttribute("data-is-pdp"); 
    }

    handleChange(options, position, formItem) {
      const selectedProduct = options
        ? this.json.find((product) => options.every((option) => product.options.includes(option)))
        : null;
      this.productComponent.updateProductInfo(selectedProduct, position);

      formItem.updateOptions(this.json);
      if (selectedProduct?.url) {
        const utmParams = sessionStorage.getItem('shopify_utm_params');

        let finalUrl = selectedProduct.url;
        if (utmParams) {
          try {
            const utm = JSON.parse(utmParams);
            const url = new URL(selectedProduct.url, window.location.origin);

            Object.entries(utm).forEach(([key, value]) => {
              url.searchParams.set(key, value);
            });

            finalUrl = url.toString();
          } catch (e) {
            console.log("Invalid UTM JSON in sessionStorage");
          }
        }

        if (this.isPDP) {
          window.history.replaceState({}, "", finalUrl);
        }
      }

    } 

    handleQuantityChange(newQuantity) {
      const product = this.querySelector("product-new-form-item[data-position='1']");

      const addProduct = (position) => {
        const newProduct = product.cloneNode(true);

        newProduct.dataset.position = position;
        newProduct.querySelectorAll("[data-position]").forEach((el) => (el.dataset.position = position));
        newProduct.classList.add("active");
        newProduct.querySelector("[data-accordion-content]").removeAttribute("style");

        const prevProduct = this.querySelector(`product-new-form-item[data-position="${position - 1}"]`);
        prevProduct.insertAdjacentHTML("afterend", newProduct.outerHTML);
      };

      const removeProduct = (position) => {
        this.querySelector(`product-new-form-item[data-position="${position}"]`)?.remove();
      };

      const actions = {
        "1->2": () => addProduct(2),
        "1->3": () => {
          addProduct(2);
          addProduct(3);
        },
        "2->1": () => removeProduct(2),
        "2->3": () => addProduct(3),
        "3->1": () => {
          removeProduct(2);
          removeProduct(3);
        },
        "3->2": () => removeProduct(3),
      };

      const actionKey = `${this.quantity}->${newQuantity}`;
      if (actions[actionKey]) {
        actions[actionKey]();
      } else {
        console.error("Invalid quantity change action");
      }

      if (newQuantity === 1 && !product.classList.contains("active")) {
        product.toggleAccordion(0);
      }

      this.quantity = newQuantity;
    }
  }

  customElements.define("product-new-form", ProductNewForm);
})();

// ProductNewFormItem
(() => {
  if (customElements.get("product-new-form-item")) return;

  class ProductNewFormItem extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector("form");
      this.parentForm = this.closest("product-new-form");

      this.accordionTitle = this.querySelector("[data-accordion-title]");
      this.accordionContent = this.querySelector("[data-accordion-content]");

      this.position = parseInt(this.dataset.position, 10);

      this.setEventListeners();
    }

    connectedCallback() {
      this.handleChange();
    }

    disconnectedCallback() {
      this.form.removeEventListener("change", this.changeHandler);
      this.accordionTitle.removeEventListener("click", this.onAccordionTitleClick);

      this.parentForm.handleChange(null, this.position, this);
    }

    setEventListeners() {
      this.changeHandler = this.handleChange.bind(this);
      this.form.addEventListener("change", this.changeHandler);

      this.onAccordionTitleClick = () => this.toggleAccordion(500);
      this.accordionTitle.addEventListener("click", this.onAccordionTitleClick);
    }

    handleChange(event) {
      if (event) {
        const input = event.target;
        const value = input.value;

        const selectedValueLabel = input.closest("[data-option]")?.querySelector("[data-option-selected-value]");
        if (selectedValueLabel) {
          selectedValueLabel.textContent = value;
        }
      }
      const formData = new FormData(this.form);
      const selectedValues = Object.fromEntries(formData.entries());
      delete selectedValues.oseid;

      this.selectedValues = selectedValues;

      this.parentForm.handleChange(Object.values(this.selectedValues), this.position, this);

      const size = this.selectedValues.size;
      if (size) {
        const swatches = document.querySelectorAll('.product-new-form__option-swatch');
        if (swatches.length > 0) {
          swatches.forEach(label => {
            const swatchSize = label.getAttribute('data-size');
            if (!swatchSize) return;
          
            if (swatchSize === size) {
              label.classList.remove('hidden');
            } else {
              label.classList.add('hidden');
            } 
          });
        }
      }
      
      const colorSelected = this.form.querySelector('.product-new-form__option--color input:checked');
      if (!colorSelected && event?.target?.closest('.product-new-form__option--size')) {
        const firstVisibleColor = this.form.querySelector('.product-new-form__option--color label:not(.hidden)');
        if (firstVisibleColor) firstVisibleColor.click();
      }      
    }

    updateOptions(products) {
      this.updateSizeOptionsImages(products);
      this.updateOptionsAvailability(products);
    }

    updateSizeOptionsImages(products) {
      const sizeImageWrappers = this.querySelectorAll("[data-size-image]");
      const selectedColor = this.selectedValues.color;
      const filteredProducts = products.filter((product) => product.options.includes(selectedColor));

      sizeImageWrappers.forEach((wrapper) => {
        const size = wrapper.dataset.sizeImage;
        const product = filteredProducts.find((prod) => prod.options.includes(size));
        const sizeImageLayout = product?.size_image;
        if (sizeImageLayout && wrapper.innerHTML !== sizeImageLayout) {
          wrapper.innerHTML = sizeImageLayout;
        }
      });
    }

    updateOptionsAvailability(products) {
      const allRadios = this.querySelectorAll("input[type='radio']");

      allRadios.forEach((radio) => {
        const radioValue = radio.value;
        const radioName = radio.name;

        const filteredProducts = products.filter((product) => product.options.includes(radioValue));

        const otherOptions = Object.keys(this.selectedValues).filter((key) => key !== radioName);
        const otherOptionsValues = otherOptions.map((key) => this.selectedValues[key]);

        const product = filteredProducts.find((prod) =>
          otherOptionsValues.every((value) => prod.options.includes(value))
        );

        radio.toggleAttribute("data-disabled", !product?.available);
      });
    }

    toggleAccordion(duration = 500) {
      if (this.isAnimating) return;

      this.classList.toggle("active");
      const isActive = this.classList.contains("active");
      isActive ? slideDown(this.accordionContent, duration) : slideUp(this.accordionContent, duration);

      this.isAnimating = true;
      setTimeout(() => {
        this.isAnimating = false;
      }, duration);
    }
  }

  customElements.define("product-new-form-item", ProductNewFormItem);
})();


// ProductNewFormQuantity
(() => {
  if (customElements.get("product-new-form-quantity")) return;

  class ProductNewFormQuantity extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector("form");
      // Find product-new-form in the document since we're now a separate block
      this.parentForm = document.querySelector("product-new-form");

      this.selectedValueEl = this.querySelector("[data-quantity-selected-value]");

      this.setEventListeners();
    }

    setEventListeners() {
      this.form.addEventListener("change", this.handleChange.bind(this));
    }

    handleChange() {
      const formData = new FormData(this.form);
      const selectedQuantity = parseInt(formData.get("quantity"), 10);

      this.parentForm.handleQuantityChange(selectedQuantity);

      const selectedValueTitle = this.querySelector(`[data-quantity-${selectedQuantity}-title]`);
      if (selectedValueTitle) {
        this.selectedValueEl.textContent = selectedValueTitle.textContent;
      }
    }

    updateLayout(selectedProducts) {
      const selectedProduct = selectedProducts[0];

      const formatPrice = (priceInCents, discount) => {
        const discountCoef = (100 - discount) / 100;
        const price = (priceInCents * discountCoef) / 100;

        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: price % 1 === 0 ? 0 : 2,
        }).format(price);
      };

      for (let i = 1; i <= 3; i++) {
        const averagePriceInCents =
          selectedProducts.reduce((acc, product, index) => {
            if (index >= i) return acc;
            return acc + parseFloat(product?.price ?? selectedProduct.price);
          }, 0) / i;

        const key = `quantity_${i}`;
        const imageEl = this.querySelector(`[data-quantity-${i}-image]`);
        const priceEl = this.querySelector(`[data-quantity-${i}-price]`);

        if (imageEl && selectedProduct[key] && imageEl.innerHTML !== selectedProduct[key].image_layout) {
          imageEl.innerHTML = selectedProduct[key].image_layout || imageEl.innerHTML;
        }

        if (priceEl && selectedProduct[key]) {
          const priceDom = new DOMParser().parseFromString(selectedProduct[key].price_layout, "text/html");

          const discount = selectedProduct[key].discount;
          const oldPriceEl = priceDom.querySelector("[data-old-price]");
          const newPriceEl = priceDom.querySelector("[data-new-price]");

          if (oldPriceEl) {
            oldPriceEl.innerHTML = formatPrice(selectedProduct.price, 0);
          }

          if (newPriceEl) {
            newPriceEl.innerHTML = formatPrice(averagePriceInCents, discount);
          }

          priceEl.innerHTML = priceDom.body.innerHTML;
        }
      }
    }
  }

  customElements.define("product-new-form-quantity", ProductNewFormQuantity);
})();
